export enum TooltipPosition {
  RIGHT_TOP = "right-top",
  DEFAULT = "default"
}

export enum TooltipTheme {
  DARK = 'dark',
  LIGHT = 'light',
  DEFAULT = 'dark'
}
